'use client';

import { Button } from '@/components/ui/button';
import Image from 'next/image';
import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';
import { useTranslations } from 'next-intl';
import { Link } from '@/i18n/routing';

export default function ArgentinaCase() {
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true, margin: "-100px" });
    const t = useTranslations('ArgentinaCase');

    return (
        <section ref={ref} className="py-8 sm:py-12 lg:py-16 w-full overflow-hidden">
            <div className="max-w-7xl mx-auto px-2 sm:px-4 lg:px-8 w-full">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8 lg:gap-12 items-center">
                    <motion.div
                        initial={{ opacity: 0, x: -50 }}
                        animate={isInView ? { opacity: 1, x: 0 } : { opacity: 0, x: -50 }}
                        transition={{ duration: 0.6, ease: "easeOut" }}
                    >
                        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-blue-600 dark:text-blue-400 mb-4 sm:mb-6">
                            {t('title')}
                        </h2>
                        <p className="text-base sm:text-lg text-gray-700 dark:text-gray-300 leading-relaxed">
                            {t('description')}
                        </p>
                        <Link href="/caso-argentina">
                            <Button className="bg-orange-500 hover:bg-orange-600 dark:bg-orange-600 dark:hover:bg-orange-700 text-white mt-6">
                                {t('button_text')}
                            </Button>
                        </Link>
                    </motion.div>
                    <motion.div
                        className="relative"
                        initial={{ opacity: 0, x: 50 }}
                        animate={isInView ? { opacity: 1, x: 0 } : { opacity: 0, x: 50 }}
                        transition={{ duration: 0.6, ease: "easeOut", delay: 0.2 }}
                    >
                        <div className="relative">
                            <Image
                                src="/macri.avif"
                                alt="Caso Argentina"
                                width={600}
                                height={400}
                                className="rounded-lg shadow-lg w-full h-auto"
                            />
                            <motion.div
                                className="absolute bottom-2 left-2 sm:bottom-4 sm:left-4 bg-yellow-400 px-2 py-1 sm:px-4 sm:py-2 rounded"
                                initial={{ opacity: 0, y: 20 }}
                                animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
                                transition={{ duration: 0.4, ease: "easeOut", delay: 0.6 }}
                            >
                                <span className="text-black font-bold text-xs sm:text-sm lg:text-lg">
                                    {t('badge_text')}
                                </span>
                            </motion.div>
                        </div>
                    </motion.div>
                </div>
            </div>
        </section>
    );
}
